(function () {
  function initialize(root) {
    root.querySelectorAll('[data-dmc-purchase]').forEach(function (widget) {
      if (widget.dataset.dmcReady === 'true') return;
      var section = widget.getAttribute('data-section-id');
      var form = document.getElementById('product-form-' + section);
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var dataNode = widget.querySelector('[data-dmc-variants]');
      if (!idInput || !dataNode) return;
      var variants;
      try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }
      var inputs = widget.querySelectorAll('input[type="radio"]');
      var once = widget.querySelector('[data-dmc-once-price]');
      var subscription = widget.querySelector('[data-dmc-sub-price]');
      var discount = widget.querySelector('[data-dmc-discount]');
      function sync() {
        var variant = variants[String(idInput.value)];
        if (!variant) return;
        once.textContent = variant.once;
        subscription.textContent = variant.sub || '';
        if (discount) {
          discount.textContent = variant.discount !== null ? widget.dataset.dmcDiscountTemplate.replace('__discount__', String(variant.discount)) : '';
          discount.hidden = variant.discount === null;
        }
        var selected = widget.querySelector('input[type="radio"]:checked');
        var activeSubscription = selected && selected.value === 'subscription' && !!variant.sellingPlanId;
        var sellingPlanInput = form.querySelector('input[name="selling_plan"][data-dmc-selling-plan]');
        if (activeSubscription) {
          if (!sellingPlanInput) {
            sellingPlanInput = document.createElement('input');
            sellingPlanInput.type = 'hidden';
            sellingPlanInput.name = 'selling_plan';
            sellingPlanInput.setAttribute('data-dmc-selling-plan', '');
            form.appendChild(sellingPlanInput);
          }
          sellingPlanInput.value = variant.sellingPlanId;
        } else if (sellingPlanInput) {
          sellingPlanInput.remove();
        }
      }
      inputs.forEach(function (input) { input.addEventListener('change', sync); });
      idInput.addEventListener('change', sync);
      form.addEventListener('submit', sync, true);
      widget.dataset.dmcReady = 'true';
      sync();
    });
  }
  function boot() { initialize(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
